import React, { useContext } from 'react';

// DEPENDENCIES
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// HELPERS/FUNCTIONS
import { RecordContext } from 'helpers/getRecordData';
import { sleep } from 'functions.js';
import { recountActions } from 'actions.js';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Sidebar from 'parts/sidebar/Sidebar';

// STYLES
import styles from './orderButton.module.scss';

// MAIN COMPONENT
const OrderButton = ({ disabled }) => {
  const { recordID } = useParams();
  const { refetchRecord } = useContext(RecordContext) || {};

  const dispatch = useDispatch();

  const handleSuccess = async () => {
    await sleep(1000);
    refetchRecord();
    dispatch(recountActions.toggle());
  };

  return (
    <>
      <Sidebar.Button name="orderSidebar" label="Order" outline fullWidth={false} size="sm" disabled={disabled} />
      <Sidebar name="orderSidebar" title="Order" className={styles.sidebar}>
        <Sidebar.Form
          method="PUT"
          endpoint={ENDPOINTS.sales.order(recordID)}
          loadingMessage="Submitting Order"
          errorMessage="Unable to submit order"
          successMessage="Sale status has been changed to ordered."
          onSuccess={handleSuccess}
          body={{ vertical: true }}
        >
          <Form.Date
            name="estimated_delivery_date"
            label="Estimated Delivery Date"
            minDate={new Date()}
            fullWidth
            required
          />
          <Form.Textarea name="order_comment" label="Comments" fullWidth />
        </Sidebar.Form>
      </Sidebar>
    </>
  );
};

// EXPORT
export default OrderButton;
